import _isString from 'lodash/isString';

import isHttpProtocol from 'utils/methods/isHttpProtocol';

const HTTP_SCHEME = /^https?:\/\//i;
// Any other scheme-looking prefix ("javascript:", "data:", "vbscript:", ...),
// excluding "host:port" which is a valid scheme-less URL.
const OTHER_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d+([/?#]|$))/i;

/**
 * Returns an http(s) URL for user/backend supplied input, or '' if it cannot
 * be one. Scheme-less input (e.g. "example.com/sale") gets an https:// prefix.
 * @param {string} value
 * @returns {string}
 */
export default function normalizeHttpUrl(value) {
  if (!_isString(value)) return '';

  const trimmed = value.trim();
  if (!trimmed) return '';

  if (!HTTP_SCHEME.test(trimmed) && OTHER_SCHEME.test(trimmed)) return '';

  const candidate = HTTP_SCHEME.test(trimmed)
    ? trimmed
    : `https://${trimmed.replace(/^\/+/, '')}`;

  try {
    const { protocol } = new URL(candidate);
    return isHttpProtocol(protocol) ? candidate : '';
  } catch (_) {
    return '';
  }
}
